/**
 * Import all the vendor specific JS files here.
 *
 * By default, modules are imported from node_modules(NPM modules)
 *
 * If the module is not a NPM module or the module is not directly available under node_modules
 * then specify the actual JS file(without .js extension)
 */

import 'babel-polyfill'
import 'jquery'
import 'bootstrap-sass'
import 'bootstrap-sass/assets/javascripts/bootstrap'
import 'axios'
import 'vue'
import 'block-ui'

// DataTable
import 'datatables.net'
import 'datatables.net-bs'
import 'datatables.net-responsive'
import 'datatables.net-responsive-bs'
import './lib/datetime-moment.js'

// DataTable Editor (Path to these modules are defined in Webpack config using resolve alias)
import 'datatables.net-editor'
import 'datatables.net-editor-bs'



// WEBPACK FOOTER //
// ./src/js/ncaa-vendor.js